/**
 * Per-step image mapping for image-mode steps.
 * Key format: `${projectId}-ch${chapterIdx+1}-s${stepIdx+1}`
 * 
 * Split into category modules for maintainability.
 */

import { CLAY_HANDMADE_IMAGES } from './step-images/clay-handmade';
import { FOOD_BAKING_IMAGES } from './step-images/food-baking';
import { PHOTOGRAPHY_IMAGES } from './step-images/photography';
import { CRAFT_IMAGES } from './step-images/craft';
import { ART_DRAWING_IMAGES } from './step-images/art-drawing';
import { GAMES_IMAGES } from './step-images/games';

export const STEP_IMAGES: Record<string, string> = {
  ...CLAY_HANDMADE_IMAGES,
  ...FOOD_BAKING_IMAGES,
  ...PHOTOGRAPHY_IMAGES,
  ...CRAFT_IMAGES,
  ...ART_DRAWING_IMAGES,
  ...GAMES_IMAGES,
};

/**
 * Runtime overrides loaded from the `video-frames` storage bucket
 * (populated by AdminVideos image generation). These take precedence
 * over the static STEP_IMAGES map so newly generated images appear
 * immediately app-wide without code edits.
 */
const RUNTIME_IMAGE_OVERRIDES: Record<string, string> = {};

export function setStepImageOverride(stepKey: string, url: string) {
  RUNTIME_IMAGE_OVERRIDES[stepKey] = url;
}

export function setStepImageOverrides(map: Record<string, string>) {
  for (const [k, v] of Object.entries(map)) RUNTIME_IMAGE_OVERRIDES[k] = v;
}

export function getStepImageUrl(projectId: string, chapterIdx: number, stepIdx: number): string | undefined {
  const key = `${projectId}-ch${chapterIdx + 1}-s${stepIdx + 1}`;
  return RUNTIME_IMAGE_OVERRIDES[key] ?? STEP_IMAGES[key];
}
